import React, { useCallback, useRef, useEffect, useState } from 'react';
// import { makeStyles } from "@material-ui/styles";
import {
  asyncLogParams,
  getImageFromFirebaseStorage,
} from '../components-logging/firebaseManager'; //turn on
import { styled, ThemeProvider } from '@mui/system';
import theme from '../Styles/MuiTheme';

// import "./ShapeDiverContainer.css";

import {
  Grid,
  Paper,
  Card,
  // Typography,
  CircularProgress,
  LinearProgress,
} from '@mui/material';
import InputManager from '../model/InputManager';
// import ExportControl from "./ExportControl.jsx";

import staticParamData from '../static/ImageLinesParams111.json';
import {
  undoAction,
  getApiValues,
  redoAction,
  UndoButton,
  RedoButton,
} from '../components-special/UndoRedo';

import { TogglePerson } from '../components-special/TogglePerson';
import { DownloadScreenCapButton } from '../components-special/ScreenCapButton';
import ContactSalesButton from '../components-special/ContactSalesButton';
import { getPaths, applyTransform } from '../helpers/SDHelpers';
import { ZoomExtents } from '../components-special/ZoomExtents';
// import CameraAltIcon from "@material-ui/icons/CameraAlt";
// import { ToggleDims } from "../components-special/ToggleDimensions";
import { SetFront } from '../components-special/SetFront';
import { SetPerspective } from '../components-special/SetPerspective';
import { restoreConfigFromFirebase } from '../components-logging/firebaseManager';
import { startupUrlTest, updateUrlEffect } from '../model/UrlManager';
import ZAHA2 from '../static/ZAHA2.jpg';

// goal: Is it possible to load the API without loading a window?  Yes, using Backend api
// goal: reference an outside component that controls a custom param control.  If that is declared, then a custom control panel will be created. If not, a generic one will be created.

const ShapediverContainer = styled(Paper)(({ theme }) => ({
  ShapediverContainer: {
    marginRight: '3em',
    marginLeft: '3em',
    display: "flex",
  },
}));

async function updateInitImage(imagePath, paramDefs, updateParam) {

  const imageId = paramDefs.find((param) => param.name === 'Image: Input');

  // Load local image
  const imageBlob = await fetch(imagePath).then((r) => r.blob());
  const imageFile = new File([imageBlob], 'ZAHA2.jpg', { type: 'image/jpeg' });
  updateParam(imageFile, imageId.id, 'file');
  console.log('imageFile: ', updateParam, imageFile);
}

export default function ShapeDiverLoad(props) {
  const containerSD = useRef();
  const sdApi = useRef();
  const [paramDefs, setParamDefs] = useState({});
  const [params, setParams] = useState({});
  const [pIdNameList, setPIdNameList] = useState({});

  const [editPaths, setEditPaths] = useState([]);
  const [previewPaths, setPreviewPaths] = useState([]);

  const [editOn, setEditOn] = useState(true);
  const [personState, setPersonState] = useState(true);

  const [busyState, setBusyState] = useState(false);
  const [progress, setProgress] = useState(0);

  const [sdData, setSdData] = useState({});

  const [timedOut, setTimedOut] = useState(false);

  const [stateFrontView, setStateFrontView] = useState(false);

  //Adding Selectable Points:
  const sphereRefs = useRef([]);
  const sphPoints = useRef([]);

  const hoverEffect = {
    active: {
      name: 'colorHighlight',
      options: {
        color: [100, 100, 100],
      },
    },
  };

  const sphereGroup = {
    id: 'spheres',
    draggable: true,
    dragEffect: hoverEffect,
    hoverable: true,
    hoverEffect: hoverEffect,
  };

  async function loadApi(api) {
    // register a ShapeDiver CommPlugin
    await api.plugins.registerCommPluginAsync({
      // ticket of the model as shown on app.shapediver.com - input in app.js
      ticket: props.ticket,

      // URL of the ShapeDiver backend system used
      // modelViewUrl: "eu-central-1",
      modelViewUrl: 'https://sdr7euc1.eu-central-1.shapediver.com',

      deferGeometryLoading: false,

      runtimeId: 'CommPlugin_1',

    });

    console.log('ShapeDiver CommPlugin successfully loaded');

    api.scene.addEventListener(api.scene.EVENTTYPE.VISIBILITY_ON, async () => {
      const start = performance.now();

      const parameters = await api.parameters.get().data;
      // console.log("Parameters: ", JSON.stringify(parameters));
      const currentParams = parameters
        .filter((p) => !p.hidden)
        .reduce((vals, def) => ({ ...vals, [def.id]: def.value }), {});

      const pIdNamePairs = parameters
        .filter((p) => !p.hidden)
        .reduce((vals, def) => ({ ...vals, [def.id]: def.name }), {});

      //From the list of all params, filter down to only ones that are not hidden
      //From filtered list, reduce to array of id:value pairs

      setParamDefs(parameters);
      setParams(currentParams);
      setPIdNameList(pIdNamePairs);
      setSdData(api.scene.getData().data[0]);

      sphPoints.current = JSON.parse(
        api.parameters.get({ name: 'Points' }).data[0].value
      )['points'];

      const end = performance.now();
      console.log(`Execution time setParamDefs: ${end - start} ms`);
    });
/////////////////////////////////////////////////////// at this section there seems to be a a lot of relaoding that occures
    // const sessionHash = startupUrlTest();
    //   console.log('sessionHash: ', sessionHash);
    //   if (typeof sessionHash !== 'undefined' ) {
    //     restoreConfigParams(sessionHash);
    //   }

    // refresh (load geometry), because the initial parameter update might not have changed any values
    await api.plugins.refreshPluginAsync('CommPlugin_1');

    const sceneSettings = {
      blurSceneWhenBusy: false,
      scene: {
        show: true,
        gridVisibility: false,
        groundPlaneVisibility: false,
        camera: {
          zoomExtentsFactor: 1, // Factor to apply to the bounding box before zooming to extents
          autoAdjust: false, // disable that the camera adjusts to geometry updates
          controls: {
            orthographic: {
              enablePan: true, // disable pan
              enableKeyPan: true, // enable key panning
              keyPanSpeed: 0.1, // set key panning speed
            },
            orbit: {
              enablePan: true, // disable pan
              enableKeyPan: true, // enable key panning
              keyPanSpeed: 0.1, // set key panning speed
              restrictions: {
                //limits camera movement in 3D scene
                rotation: {
                  minPolarAngle: -90,
                  maxPolarAngle: 90,
                  minAzimuthAngle: -90,
                  maxAzimuthAngle: 90,
                },
              },
            },
          },
        },
      },
    };

    await api.updateSettingsAsync(sceneSettings);

    // This section all about api display of geometry.  Goal is to show/hide edit mode using api instead of param call to gh
    // paths cannot be collected unless geometry is in show state.

    const editGeoPaths = getPaths(api, [
      'Sphere',
      'Tweens',
      'GuideCrvs',
      'ImageDisplay',
    ]);
    setEditPaths(editGeoPaths);

    const hideNow = getPaths(api, ['GroundPlane']);

    const previewGeoPaths = getPaths(api, [
      'Person',
      'Mapped Surface',
      'Other Color',
      'PanelReturns',
    ]);
    setPreviewPaths(previewGeoPaths);

    // console.log(
    //   `JSON.stringify(previewGeoPaths): ${JSON.stringify(
    //     previewGeoPaths
    //   )}, ${previewGeoPaths}`
    // );

    api.scene.toggleGeometry(
      [...previewGeoPaths],
      [...editGeoPaths, ...hideNow]
    );
    /////////////////////////////////////////////////////// at this section there seems to be a a lot of relaoding that occures
    // startupUrlTest(restoreConfigParams);
      // console.log('sessionHash: ', sessionHash);
      // if (typeof sessionHash !== 'undefined' ) {
      //   restoreConfigParams(sessionHash);
      // }

  }

  const { liveLink } = props || true; //Controls whether SD is initialized or uses set of static variables

  useEffect(() => {
    if (!liveLink) {
      //for static version of params for work on UI
      const staticParams = staticParamData
        .filter((p) => (p.hidden = 'false'))
        .reduce((vals, p) => ({ ...vals, [p.id]: p.value }), {});
      // //set paired id's and values to params
      setParams(staticParams);
      setParamDefs(staticParamData);
    } else {
      // container for the viewer

      let _container = containerSD.current;

      // ShapeDiver Viewer constructor settings
      // Refer to https://app.shapediver.com/api for details

      let settings = {
        container: _container,
        api: { version: 2 }, // use v2 of the API
        showSceneMode: 1, // do not show the scene automatically
      };

      // construct an instance of the viewer
      const api = (sdApi.current = new window.SDVApp.ParametricViewer(
        settings
      ));
      // const api = sdApi.current;

      loadApi(api).then(() => {
        api.scene.updateInteractionGroups(sphereGroup);

        const assets = api.scene.get(null, 'CommPlugin_1');
        const sphereAssets = assets.data.filter((a) => a.format !== 'material');
        var updateObjects = [];
        for (let assetnum in sphereAssets) {
          let asset = sphereAssets[assetnum];
          // console.log(`asset: ${JSON.stringify(asset)}`);
          if (asset.name.includes('Sphere_')) {
            let updateObject = {
              id: asset.id,
              duration: 0,
              interactionGroup: sphereGroup.id,
              name: asset.name,
            };
            updateObjects.push(updateObject);
          }
        }
        sphereRefs.current = updateObjects;
        api.scene.updatePersistentAsync(updateObjects, 'CommPlugin_1');
        api.scene.addEventListener(api.scene.EVENTTYPE.DRAG_END, dragCallback);
        api.state.addEventListener(api.state.EVENTTYPE.BUSY, busySpinner);
        api.state.addEventListener(api.state.EVENTTYPE.IDLE, busySpinner);
        api.state.addEventListener(api.state.EVENTTYPE.MESSAGE, (event) => {
          handleTimeOut();
        });
        api.state.addEventListener(
          api.parameters.EVENTTYPE.VALUE_UPDATE,
          sdValueUpdate
        );
      });
    }



  }, []); //Empty Array here means this function will run once and will not update.
  
  
/////////////////////////////////////////////////////////////////////////////////////////
  // load the url sessionHash
  // only want to call it after the api is loaded

  useEffect(() => {
    if (paramDefs && paramDefs.length > 0) {

        // updateInitImage(ZAHA2, paramDefs, updateParam); //comented due to reload UX
        startupUrlTest(restoreConfigParams);

      }
    // }

  // }, []);
  // }, [paramDefs, sdData, timedOut, handleTimeOut, sdValueUpdate]);

  }, [paramDefs]);
  // update Parameter functions

  const sdValueUpdate = () => {
    const dataUpdate = sdApi.current.scene.getData().data[0];
    console.log('dataUpdate: ', dataUpdate);
    setSdData(dataUpdate);
  };

  const handleTimeOut = () => {
    // alert(
    //   "Operation timed out.  Please reduce size and/or complexity of design."
    // );
    asyncLogParams('TimeOut', 1).then(() => {
      setTimedOut(true);
    });
    // undoAndSync();
  };

  const updateParam = (value, id, type) => {
    // write time to run function to console
    const start = performance.now();

    setParams((prev) =>
      type === 'file' ? { ...prev, [id]: value.name } : { ...prev, [id]: value }
    );

    console.log('updateParam: ', id, value);
    if (sdApi && sdApi.current) {
      sdApi.current.parameters
        .updateAsync({ id, value })
        .then(function (response) {
          // console.log("Promise result: ", JSON.stringify(response));
          if (response['data']) {
            setTimedOut(false);
            // updateViewState(true);
          }
          // else setTimedOut(true);
        })
        .then(asyncLogParams(pIdNameList[id], value));
      // .then(function (result) {
      updateViewState(true); //this could be used to target goemetry under different conditions - edit vs. preview geometry
      // can set new camera view as default by setting "default:true" in transition settings
      // });
      // This is where logging goes.  also add log of errors/failed calls to api
      // Also add log entry in updatePoints()
      console.log('id, value, type: ', id, value, type);
      // console.log(`previewPaths: ${JSON.stringify(previewPaths)}`);
      // sdApi.current.scene.camera.zoomAsync(previewPaths);

      // need to log if this fails and the sdApi is not updated
      // sdApi.current.scene.camera.zoomAsync(previewPaths);

      const end = performance.now();
      console.log(`Execution time: ${end - start} ms`);
    }
  };
  // , []);

  const updateParamNoSD = useCallback((value, id, type) => {
    setParams((prev) =>
      type === 'file' ? { ...prev, [id]: value.name } : { ...prev, [id]: value }
    );
  }, []);

  // More on selectable points:
  const dragCallback = (event) => {
    const sphereID = event.scenePath.split('.')[1];
    // console.log("sphereId: ", sphereID);

    const selectedSph = sphereRefs.current
      .find((ref) => ref.id === sphereID)
      .name.split('_')[1];

    const tFormName = selectedSph < 5 ? 'TForm1' : 'TForm2'; //assumes 4 points per curve - this may not always be true
    // console.log("tFormName ", tFormName);

    const tForm = getDataByName(tFormName);
    const newPos = event.dragPosAbs;

    const tPos = applyTransform(newPos, tForm);

    let tempPts = sphPoints.current;
    // let tempPts = getDataByName("points");
    console.log('tempPts: ', tempPts);

    tempPts.splice(selectedSph - 1, 1, [tPos.x, tPos.y, tPos.z]);
    // console.log("drag tempPts spliced: ", tempPts);

    updatePoints(tempPts, 'move');
  };

  function updatePoints(pts, logName) {
    sphPoints.current = pts;
    const logType = logName ? 'Points-' + logName : 'Points';
    // console.log("pts to update: ", JSON.stringify(pts));
    sdApi.current.parameters
      .updateAsync({
        name: 'Points',
        value: JSON.stringify({ points: pts }),
      })
      .then((response) => {
        if (response['data']) setTimedOut(false);
      })
      .then(asyncLogParams(logType, 1, JSON.stringify({ points: pts })));
    updateViewState(true);
    // .then(updateViewState(true));
  }

  const getDataByName = (dataName) => {
    // console.log(
    //   `dataname ${dataName}: sdApi.current.scene.getData(): ${JSON.stringify(
    //     sdApi.current.scene.getData()
    //   )} `
    // );
    const dataObj = sdApi.current.scene.getData().data[0];
    // console.log("data: ", JSON.stringify(dataObj.data[dataName]));
    // console.log(`dataObj.data[${dataName}]: `, dataObj.data[dataName]);
    if (dataObj) return dataObj.data[dataName];
    else {
      // console.log(
      //   `sdData.data[dataName]: ${JSON.stringify(sdData.data[dataName])}`
      // );
      return sdData.data[dataName];
    }
  };

  const resetPoints = () => {
    sphPoints.current = [
      [0, 0, 0],
      // [null], //this works - use nulls as placeholders if adding and removing points
      [0, 0.333333, 0],
      [0, 0.666667, 0],
      [0, 1, 0],
      [0, 0, 0],
      [0, 0.333333, 0],
      [0, 0.666667, 0],
      [0, 1, 0],
    ];
    updatePoints(sphPoints.current, 'reset');
  };

  const undoAndSync = () => {
    if (undoAction(sdApi)) {
      const newParams = getApiValues(sdApi, params);
      setParams((prev) => ({ ...newParams }));
      asyncLogParams('Undo', -1);
      setTimedOut(false); //This isn't quite right - sometimes an undo won't fix a timeOut
    }
  };

  const redoAndSync = () => {
    if (redoAction(sdApi)) {
      const newParams = getApiValues(sdApi, params);
      setParams((prev) => ({ ...newParams }));
      asyncLogParams('Redo', 1);
    }
  };

  const toggleEditMode = (override) => {
    if (override !== editOn) {
      setEditOn(override);
      // setEditOn(!editOn);
      // console.log(`editOn.toString(): ${editOn.toString()}`);
      // console.log(`previewPaths: ${previewPaths}`);
      // updateViewState();
    }
  };

  useEffect(() => {
    updateViewState();
  }, [editOn]);

  const updateViewState = (reverse) => {
    //maybe useCallback and memo-ize?
    const previewPathsSelected = personState ? previewPaths : [previewPaths[1]];
    // console.log(`previewPaths: ${previewPaths}`);
    const toShow = editOn
      ? [previewPathsSelected, editPaths]
      : [editPaths, previewPathsSelected];
    // if (reverse) toShow.reverse();
    sdApi.current.scene.toggleGeometry(...toShow);
    sdApi.current.scene.camera.zoomAsync(toShow[0])
    sdApi.current.updateSettingAsync('scene.camera.controls.orbit.enableKeyPan', true);
    // sdApi.current.updateSettingAsync('scene.groundPlaneVisibility', editOn);
  };

  const updateViewStateFront = (reverse) => {
    //maybe useCallback and memo-ize?
    //post on camera manipulation https://discourse.mcneel.com/t/camera-position/82939/9
    // restoreConfigParams();
    if (!stateFrontView) {
      setStateFrontView(true);
      

      const previewPathsSelected = personState
        ? previewPaths
      : [previewPaths[1]];

      console.log(`previewPaths: ${previewPaths}`);

      const toShow = editOn	
        ? [previewPathsSelected, editPaths]
        : [editPaths, previewPathsSelected];

      sdApi.current.scene.toggleGeometry(...toShow);
      sdApi.current
        .updateSettingAsync('scene.camera.cameraTypes.active', 6)
        .then(() => {
          // sdApi.current.updateSettingAsync("scene.groundPlaneVisibility", editOn);
          sdApi.current.updateSettingAsync('scene.camera.controls.orthographic.enableKeyPan', true);
        }).then(() => {
          sdApi.current.scene.camera.zoomAsync(toShow[0]);
        });




    } else {
      sdApi.current.updateSettingAsync('scene.camera.cameraTypes.active', 0);
      setStateFrontView(false);
    }

  };

  const updateViewStatePerspective = (reverse) => {
    //maybe useCallback and memo-ize?
    //post on camera manipulation https://discourse.mcneel.com/t/camera-position/82939/9

    const previewPathsSelected = personState ? previewPaths : [previewPaths[1]];
    console.log(`previewPaths: ${previewPaths}`);
    const toShow = editOn
      ? [previewPathsSelected, editPaths]
      : [editPaths, previewPathsSelected];
    sdApi.current.scene.toggleGeometry(...toShow);
    sdApi.current.updateSettingAsync('scene.camera.cameraTypes.active', 0);
    // sdApi.current.updateSettingAsync("scene.groundPlaneVisibility", editOn);
    console.log(`toShow: ${toShow}`);
    sdApi.current.scene.camera.zoomAsync(toShow[1]);
  };

  const busySpinner = (event) => {
    // const start = performance.now();
    const state = sdApi.current.state.get().data;
    // console.log(`JSON.stringify(state): ${JSON.stringify(state)}`);
    if (state.busy) {
      setBusyState(true);
      setProgress(state.progress);
    } else {
      setProgress(state.progress);
      setBusyState(false);
    }
    // const end = performance.now();
    // console.log(`Execution time busySpinner: ${end - start} ms`);
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // function to restore configurations of parameters from a firebase import
  // this doesn't make sense to use a lookup - there should just be a mapping of the and save as an object in the firebase db
  const lookupValuesparamNames = {
    // "Points": PointJson,
    // "TForm1": TForm1Json,
    // "TForm2": TForm2Json,
    imageBlob: 'Rectangle',
    'Scope: Height': 'Height',
    'Scope: Width': 'Width',
    'Lines: Per Ft': 'LinesPerFt',
    'Lines: Rotation': 'Rotation',
    Material: 'Material',
    'Image: Crop/Stretch': 'ImageCrop',
    'Image: Invert Sampling': 'ImageInvert',
  };

  async function restoreConfigParams(inputHashCode) {
    // url to test http://localhost:3000/?session=z75Uym
    // // restore the parameters with the restoreConfig object
    // // items to restore: Height, Width, Points (Points is an array of points), TForm1, TForm2, Image, ImageHighRes, ImageEdited, Rectangle, LinesPerFt, Rotation, Material, ImageCrop, ImageInvert
    // const inputHashCode = 'z75Uym';
    const restoreConfig = await restoreConfigFromFirebase(inputHashCode);
    const newParams = getApiValues(sdApi, params);
    // console.log(" newParams: ", newParams);
    // console.log("restoreConfig: ", restoreConfig.DataOutputs);

    // set image from firebase storage
    const imageId = paramDefs.find((param) => param.name === 'Image: Input');
    const imagereturned = await getImageFromFirebaseStorage(inputHashCode);
    // newParams[imageId.id] = imagereturned // issue with this at the moment, seems to conlict with the way some of the update params works downstream
    updateParam(imagereturned, imageId.id, 'file');

    // updateParam
    // limit loop to only items in the lookup value object
    for (const key of Object.keys(lookupValuesparamNames)) {
      const paramDefinition = paramDefs.find((param) => param.name === key);
      console.log('paramDefinition: ', paramDefinition);

      if (paramDefinition) {
        const { id } = paramDefinition;
        const value = restoreConfig.DataOutputs[lookupValuesparamNames[key]];
        newParams[id] = value;
      }
    }

    console.log('newParams: ', newParams);
    const newParamsList = Object.keys(newParams).map((key) => {
      return { id: key, value: newParams[key] };
    });

    // update all params
    // Update the parameter asynchronously
    sdApi.current.parameters.updateAsync(newParamsList).then((response) => {
      // console.log("Promise result: ", JSON.stringify(response));
      setParams((prev) => ({ ...newParams }));
      if (response['data']) {
        setTimedOut(false);
      }
    });

    // set sphere points
    const data = JSON.parse(restoreConfig.DataOutputs.Points);
    const pointsArray = data.points;

    updatePoints(pointsArray, 'move');

    console.log('params should be updated now', params);
    console.log('newParams Post: ', newParams);
    // asyncLogParams("restored", 1); // does this break or is it called everytime the page refreshes?
  }

  const canRenderParams = paramDefs && Object.keys(params).length;
  // console.log("Can it render?", canRenderParams);

  return (
    <div>
      <ThemeProvider theme={theme}>
        {/* <ShapediverContainer> */}
          <Grid
            container
            spacing={1}
            direction='row-reverse'
            alignContent='center'
            style={{ padding: 10 }}
            // boxShadow= 'none' // remove shadow on bottom
          >
            <Grid item xs={12}>
              <LinearProgress
                variant='determinate'
                style={{
                  height: 8,
                }}
                value={progress * 100}
                color={progress === 1 ? 'secondary' : 'primary'}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              {/* <!-- ShapeDiver Viewer Main Container --> */}
              {liveLink ? (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    minHeight: 600,
                    maxHeight: 750,
                    flexShrink: 3,
                    // position: "sticky",
                  }}
                >
                  <Paper
                    color='secondary'
                    variant='outlined'
                    style={{
                      width: '100%',
                      height: '100%',
                      minHeight: 600,
                      maxHeight: 750,
                      flexShrink: 3,
                      // position: "sticky",
                    }}
                  >
                    {/* <ShapediverContainer> */}
                    <div
                      // className={classes.ShapediverContainer}
                      id='sdv-container'
                      ref={containerSD}
                      style={{
                        position: 'relative',
                        height: '100%',
                        width: '100%',
                      }}
                    />
                     {/* </ShapediverContainer> */}
                    <div
                      style={{
                        position: 'relative',
                        bottom: 50,
                        left: 10,
                        zIndex: 10,
                        marginBottom: '-65px',
                        justifyContent: 'right',
                      }}
                    >
                      <UndoButton
                        undoAndSync={undoAndSync}
                        timedOut={timedOut}
                      />
                      <RedoButton redoAndSync={redoAndSync} />{' '}
                      <TogglePerson
                        sdApi={sdApi}
                        personState={personState}
                        setPersonState={setPersonState}
                        editOn={editOn}
                        asyncLogParams={asyncLogParams}
                      />
                      <ZoomExtents
                        updateViewState={updateViewState}
                        asyncLogParams={asyncLogParams}
                      />
                      <SetFront
                        updateViewState={updateViewStateFront}
                        asyncLogParams={asyncLogParams}
                      />
                      <SetPerspective
                        updateViewState={updateViewStatePerspective}
                        asyncLogParams={asyncLogParams}
                      />
                      {/* <ToggleDims
                        sdApi={sdApi}
                        dimState={dimState}
                        setDimState={setDimState}
                        editOn={editOn}
                        asyncLogParams={asyncLogParams}
                      /> */}
                      {/* <ScreenCapButton sdApi={sdApi} /> */}
                      <p />
                      {busyState ? (
                        <CircularProgress
                          variant='indeterminate'
                          size={20}
                          thickness={5}
                          value={progress * 100}
                          color={progress === 1 ? 'secondary' : 'primary'}
                        />
                      ) : (
                        <div />
                      )}
                    </div>
                  </Paper>
                </div>
              ) : (
                <Card>
                  <div
                    style={{
                      position: 'relative',
                      top: 50,
                      left: 20,
                      zIndex: 4,
                    }}
                  >
                    <UndoButton undoAndSync={undoAndSync} timedOut={timedOut} />
                    <RedoButton redoAndSync={redoAndSync} />
                    <TogglePerson
                      sdApi={sdApi}
                      personState={personState}
                      setPersonState={setPersonState}
                      editOn={editOn}
                    />
                    {/* <ScreenCapButton sdApi={sdApi} /> */}
                  </div>
                  <Paper
                    color='secondary'
                    variant='outlined'
                    style={{
                      width: '100%',
                      height: '100%',
                      minHeight: 600,
                      maxHeight: 750,
                      flexShrink: 3,
                    }}
                  />
                </Card>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              justifyContent='center'
              alignItems='center'
            >
              <Paper style={{ height: 750 }} variant='outlined'>
                <div
                  style={{
                    position: 'relative',
                    top: 700,
                    left: 15,
                    zIndex: 0,
                  }}
                >
                  <Grid container direction='row' spacing={2} >
                    <Grid item>
                      <DownloadScreenCapButton
                        sdApi={sdApi}
                        paramDefs={paramDefs}
                        setBusyState={setBusyState}
                        setProgress={setProgress}
                      />
                    </Grid>
                    <Grid item>
                      {/* <div style={{ position: "relative", top: 550, left: 100, zIndex: 0 }}> */}
                      <ContactSalesButton />
                      {/* </div> */}
                    </Grid>
                  </Grid>
                </div>

                <Grid item>
                  <div
                    id='controls'
                    style={{   zIndex: 2, position: 'relative', bottom: 38,  }}
                  >
                    {canRenderParams ? (
                      <InputManager
                        updateParams={updateParam}
                        updateParamNoSD={updateParamNoSD}
                        paramData={paramDefs}
                        params={params}
                        resetPoints={resetPoints}
                        updatePoints={updatePoints}
                        sdApi={sdApi}
                        toggleEditMode={toggleEditMode}
                        editOn={editOn}
                        getDataByName={getDataByName}
                      />
                    ) : (
                      <div />
                    )}
                  </div>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12}></Grid>
          </Grid>
        {/* </ShapediverContainer> */}
      </ThemeProvider>
    </div>
  );
}
